import {set as lockrSet, get as lockrGet } from 'lockr';
import {selectArtworkQuery, selectCurrentProfileId} from '../selectors';
import {routeUrl} from '../util/routeUrl';
import {clearArtworkSelection, selectArtworks, selectedArtworks} from '../slices/artworkSlice';

export const artworkMiddleware = (store) => (next) => async (action) => {

	const result = next(action);

	// Fetch artworks when the artwork query is set
	if (action.type === 'artwork/setArtworkQuery') {
		const query = selectArtworkQuery(store.getState());
		const trimmedQuery = {};
		// copy all poperties from query, when not empty
		for (const key in query) {
			if (query[key]) {
				trimmedQuery[key] = query[key];
			}
		}
	}

	// redirect to the newly created artwork detail page after creation
	if (action.type ===  'artwork/create/fulfilled' || action.type ===  'artwork/duplicate/fulfilled') {
		const artworkId = action.payload?.item?.id;
		if (artworkId) {
			const lang = store.getState().status.lang || {};
			const profileId = selectCurrentProfileId(store.getState());
			window.location.href = routeUrl('artwork', {
				language: lang,
				id: profileId,
				artworkId: artworkId,
			});
		}
	}

	// save selected artworks to local storage
	if (
		action.type === 'artwork/selectArtworks' ||
		action.type === 'artwork/deselectArtworks' ||
		action.type === 'artwork/selectArtwork' ||
		action.type === 'artwork/deselectArtwork' ||
		action.type === 'artwork/clearArtworkSelection'
	) {
		const profileID = selectCurrentProfileId(store.getState());
		lockrSet('arc_selectedArtworks_' + profileID, selectedArtworks(store.getState()));
	}

	if (action.type === 'artwork/fetchAll/fulfilled') {
		const profileID = selectCurrentProfileId(store.getState());
		const selected = lockrGet('arc_selectedArtworks_' + profileID);
		if (selected) {
			store.dispatch(selectArtworks({ artworkIds: selected}));
		}
	}

	// load selected artworks when changing profile
	if (action.type === 'profile/setCurrentProfileId') {
		const profileID = selectCurrentProfileId(store.getState());
		const selected = lockrGet('arc_selectedArtworks_' + profileID);
		if (selected) {
			store.dispatch(selectArtworks({artworkIds: selected}));
		}
	}

	return result;
};
